<template>
    <AisInstantSearch
        v-if="searchClient"
        id="filter-page"
        :class="{ collapsed: collapsed }"
        class="filter-content"
        :routing="routing"
        :future="{
            preserveSharedStateOnUnmount: true,
        }"
        :search-client="searchClient"
        :index-name="indexName"
    >
        <AisConfigure ref="configure" :filters="refine" />

        <!-- Sidebar -->
        <section class="filter" ref="filter">
            <div class="filter-button-container">
                <button
                    class="filter-button"
                    :class="{ active: !collapsed }"
                    id="filter-button-top"
                    @click="toggleCollapse"
                >
                    <span class="collapsed">Filtrer søk</span>
                    <span class="active">Vis resultat</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30.747" height="27">
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="M9.03 0a4.023 4.023 0 00-3.838 2.89H1.084A1.081 1.081 0 000 4.019a1.118 1.118 0 001.129 1.129h4.109a3.982 3.982 0 003.838 2.89 4.036 4.036 0 003.883-2.89h16.66a1.129 1.129 0 000-2.258H12.96A4.134 4.134 0 009.03 0zm.045 2.258a1.761 1.761 0 11-1.761 1.761 1.763 1.763 0 011.761-1.761z"
                                        fill="currentColor"
                                    />
                                </g>
                                <g>
                                    <path
                                        d="M22.62 9.03a4.023 4.023 0 00-3.838 2.89H1.129A1.091 1.091 0 000 13.049a1.118 1.118 0 001.129 1.129h17.654a3.982 3.982 0 003.838 2.89 4.036 4.036 0 003.883-2.89h3.115a1.129 1.129 0 000-2.258h-3.116a4.036 4.036 0 00-3.883-2.89zm.045 2.258a1.761 1.761 0 11-1.761 1.761 1.735 1.735 0 011.762-1.761z"
                                        fill="currentColor"
                                    />
                                </g>
                                <g>
                                    <path
                                        d="M14.448 18.963a4.023 4.023 0 00-3.838 2.89H1.129A1.091 1.091 0 000 22.982a1.118 1.118 0 001.129 1.132h9.531a3.982 3.982 0 003.838 2.89 4.036 4.036 0 003.883-2.89h11.238a1.129 1.129 0 000-2.258H18.331a4.036 4.036 0 00-3.883-2.893zm.045 2.258a1.761 1.761 0 11-1.761 1.761 1.793 1.793 0 011.761-1.761z"
                                        fill="currentColor"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                </button>
            </div>

            <!-- Filter -->
            <div class="filter-container">
                <h1>Finn din reise</h1>

                <template v-if="!crawler">
                    <FilterSidebarItem
                        v-show="!['airport'].includes(pageType)"
                        name="startDates.airports.title"
                        title="Avreiseflyplass"
                        :sort-by="['count:desc']"
                        :show-more="true"
                    />

                    <FilterSidebarDates
                        name="startDates.month"
                        title="Avreisetidspunkt"
                        :sort-by="['name:asc']"
                        :show-more="true"
                    />

                    <FilterSidebarItem
                        v-show="
                            !['travelType', 'travelTypeCountry', 'travelTypeCountryPlace'].includes(
                                pageType
                            )
                        "
                        name="travelTypes.title"
                        title="Reisetyper"
                        :sort-by="['count:desc']"
                        :show-more="true"
                    />

                    <FilterSidebarDurationItem name="durations" title="Reiselengde" />

                    <FilterSidebar
                        :entry="entry"
                        :places="sidebarPlaces"
                        :countries="sidebarCountries"
                        :page-type="pageType"
                        :travel-type="sidebarTravelType"
                    />
                </template>
            </div>
        </section>

        <section class="content">
            <slot
                name="intro"
                :toggleIntro="
                    () => {
                        introCollapsed = !introCollapsed
                    }
                "
                :introCollapsed="introCollapsed"
            />

            <button class="filter-button" id="filter-button-bottom" @click="toggleCollapse">
                <span class="collapsed">Filtrer søk</span>
                <span class="active">Vis resultat</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="30.747" height="27">
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M9.03 0a4.023 4.023 0 00-3.838 2.89H1.084A1.081 1.081 0 000 4.019a1.118 1.118 0 001.129 1.129h4.109a3.982 3.982 0 003.838 2.89 4.036 4.036 0 003.883-2.89h16.66a1.129 1.129 0 000-2.258H12.96A4.134 4.134 0 009.03 0zm.045 2.258a1.761 1.761 0 11-1.761 1.761 1.763 1.763 0 011.761-1.761z"
                                    fill="currentColor"
                                />
                            </g>
                            <g>
                                <path
                                    d="M22.62 9.03a4.023 4.023 0 00-3.838 2.89H1.129A1.091 1.091 0 000 13.049a1.118 1.118 0 001.129 1.129h17.654a3.982 3.982 0 003.838 2.89 4.036 4.036 0 003.883-2.89h3.115a1.129 1.129 0 000-2.258h-3.116a4.036 4.036 0 00-3.883-2.89zm.045 2.258a1.761 1.761 0 11-1.761 1.761 1.735 1.735 0 011.762-1.761z"
                                    fill="currentColor"
                                />
                            </g>
                            <g>
                                <path
                                    d="M14.448 18.963a4.023 4.023 0 00-3.838 2.89H1.129A1.091 1.091 0 000 22.982a1.118 1.118 0 001.129 1.132h9.531a3.982 3.982 0 003.838 2.89 4.036 4.036 0 003.883-2.89h11.238a1.129 1.129 0 000-2.258H18.331a4.036 4.036 0 00-3.883-2.893zm.045 2.258a1.761 1.761 0 11-1.761 1.761 1.793 1.793 0 011.761-1.761z"
                                    fill="currentColor"
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            </button>

            <!-- Tour list -->
            <template v-if="!crawler">
                <AisInfiniteHits :transform-items="transformTrips">
                    <template v-slot:default="{ items, isLastPage, refineNext }">
                        <div class="none" v-if="items?.length === 0">
                            <h3 v-if="pageType === 'travelCalendar'">
                                Ingen planlagte turer for øyeblikket
                            </h3>
                            <h3 v-else>
                                Ingen planlagte turer {{ pageType === 'airport' ? 'fra' : 'til' }}
                                {{ title }} for øyeblikket
                            </h3>
                            <p>
                                Ring oss gjerne på
                                <a href="tel:90166999">901 66 999</a> for informasjon om kommende
                                turer eller andre gode alternativer.
                            </p>
                            <p>
                                Meld deg på vårt
                                <a href="/nyhetsbrev">nyhetsbrev her</a> og hold deg oppdatert om
                                kommende turer og nye spennende reisemål.
                            </p>
                            <p>
                                Om du lurer på noe omkring våre reiser og destinasjoner.
                                <a href="/kontakt-oss">Kontakt oss gjerne</a>.
                            </p>
                        </div>
                        <template v-else>
                            <div
                                class="partials trip-card"
                                v-for="trip in items"
                                :key="trip.tourId"
                            >
                                <div class="image">
                                    <a
                                        :href="trip.url"
                                        @click.prevent="onTripClicked(trip, trip.index)"
                                    >
                                        <img
                                            v-if="trip.image.url"
                                            :src="'https://vitus.imgix.net/' + trip.image.url"
                                            :srcset="generateSrcSet(trip.image.url)"
                                            :alt="trip.image.alt"
                                            :title="trip.image.alt"
                                            :loading="trip.index.index !== 0 ? 'lazy' : 'eager'"
                                        />
                                        <img
                                            v-else-if="trip.image.fallback"
                                            :src="'https://vitus.imgix.net/' + trip.image.fallback"
                                            :srcset="generateSrcSet(trip.image.fallback)"
                                            :alt="trip.image.alt"
                                            :title="trip.image.alt"
                                            :loading="trip.index.index !== 0 ? 'lazy' : 'eager'"
                                        />
                                    </a>
                                </div>
                                <div class="content-area">
                                    <h2 class="headline">
                                        <a
                                            :href="trip.url"
                                            @click.prevent="onTripClicked(trip, trip.index.index)"
                                        >
                                            {{ trip.title }}
                                        </a>
                                    </h2>

                                    <div class="split">
                                        <div class="checklist-container">
                                            <ul v-if="trip.checklist">
                                                <li v-for="item in trip.checklist">{{ item }}</li>
                                            </ul>
                                            <div
                                                class="departure"
                                                v-if="trip.startDates.length > 0"
                                            >
                                                <span>Avreise:</span>
                                                {{ getAirportListForTrip(trip) }}
                                            </div>
                                        </div>
                                        <div class="read-more">
                                            <div v-if="trip && trip.price > 0" class="price">
                                                <span>Pris fra kr.</span>
                                                {{
                                                    '&nbsp;' +
                                                    trip.price?.toLocaleString('no-nb') +
                                                    ',-'
                                                }}
                                            </div>
                                            <div v-else>&nbsp;</div>
                                            <a
                                                :href="trip.url"
                                                class="button"
                                                @click.prevent="
                                                    onTripClicked(trip, trip.index.index)
                                                "
                                            >
                                                Les mer
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div style="display: flex; justify-content: center">
                            <button
                                class="btn button-outline"
                                v-show="!isLastPage"
                                @click="refineNext"
                            >
                                Laste inn flere reiser
                            </button>
                        </div>
                    </template>
                </AisInfiniteHits>
            </template>
            <template v-else>
                <div class="none">
                    <h3 v-if="pageType === 'travelCalendar'">
                        Ingen planlagte turer for øyeblikket
                    </h3>
                    <h3 v-else>
                        Ingen planlagte turer {{ pageType === 'airport' ? 'fra' : 'til' }}
                        {{ title }} for øyeblikket
                    </h3>
                    <p>
                        Ring oss gjerne på
                        <a href="tel:90166999">901 66 999</a> for informasjon om kommende turer
                        eller andre gode alternativer.
                    </p>
                    <p>
                        Meld deg på vårt
                        <a href="/nyhetsbrev">nyhetsbrev her</a> og hold deg oppdatert om kommende
                        turer og nye spennende reisemål.
                    </p>
                    <p>
                        Om du lurer på noe omkring våre reiser og destinasjoner.
                        <a href="/kontakt-oss">Kontakt oss gjerne</a>.
                    </p>
                </div>
            </template>

            <slot />
        </section>
        <div v-show="false">
            <!-- Needed for url-filtering to work properly -->
            <AisRefinementList attribute="travelTypes.title" />
            <AisRefinementList attribute="startDates.airports.title" />
            <AisRefinementList attribute="startDates.month" />
            <AisRefinementList attribute="durations" />
        </div>
    </AisInstantSearch>
</template>
<script>
    import algoliasearch from 'algoliasearch/lite'
    import ImgixClient from '@imgix/js-core'
    import FilterSidebar from './FilterSidebar.vue'
    import FilterSidebarItem from './FilterSidebarItem.vue'
    import FilterSidebarDates from './FilterSidebarDates.vue'
    import FilterSidebarPlaces from './FilterSidebarPlaces.vue'
    import FilterSidebarCountries from './FilterSidebarCountries.vue'
    import FilterSidebarDurationItem from './FilterSidebarDurationItem.vue'
    import { history as historyRouter } from 'instantsearch.js/es/lib/routers'
    import { uniq } from 'lodash/array'

    export default {
        name: 'FilterPage',
        components: {
            FilterSidebarDurationItem,
            FilterSidebarCountries,
            FilterSidebarPlaces,
            FilterSidebarDates,
            FilterSidebarItem,
            FilterSidebar,
        },
        props: {
            title: {
                type: String,
                required: false,
                default: 'dette stedet',
            },
            entry: {
                type: Object,
                required: true,
            },
            category: {
                type: String,
                default: 'Undefined',
            },
            airports: {
                type: Array,
                required: true,
            },
            pageType: {
                type: String,
                required: true,
            },
            sidebarCountries: {
                type: [],
                required: false,
            },
            sidebarPlaces: {
                type: [],
                required: false,
            },
            sidebarTravelType: {
                type: String,
            },
            algoliaId: {
                type: String,
            },
            algoliaKey: {
                type: String,
            },
        },
        data() {
            return {
                indexName: 'trips',
                searchClient: algoliasearch(this.algoliaId, this.algoliaKey),
                collapsed: true,
                introCollapsed: true,
                refine: '',
                crawler: true,
                slug: window.location.pathname.substring(1).split('/').slice(-1),
                firstSlug: window.location.pathname.substring(1).split('/')[0],
                secondSlug: window.location.pathname.substring(1).split('/')[1],
                routing: {
                    router: historyRouter({
                        cleanUrlOnDispose: true,
                    }),
                    stateMapping: {
                        stateToRoute(uiState) {
                            const tripsState = uiState['trips'] || {}

                            return {
                                'travel-types':
                                    tripsState.refinementList &&
                                    tripsState.refinementList['travelTypes.title'],
                                airports:
                                    tripsState.refinementList &&
                                    tripsState.refinementList['startDates.airports.title'],
                                months:
                                    tripsState.refinementList &&
                                    tripsState.refinementList['startDates.month'],
                                durations:
                                    tripsState.refinementList &&
                                    tripsState.refinementList['durations'],
                            }
                        },
                        routeToState(routeState) {
                            return {
                                trips: {
                                    refinementList: {
                                        'travelTypes.title': routeState['travel-types'],
                                        'startDates.airports.title': routeState['airports'],
                                        'startDates.month': routeState['months'],
                                        durations: routeState['durations'],
                                    },
                                },
                            }
                        },
                    },
                },
            }
        },
        mounted() {
            switch (this.pageType) {
                case 'travelCalendar': {
                    this.refine = ''
                    break
                }
                case 'travelTypeCountry': {
                    this.refine =
                        'travelTypes.slug:' + this.firstSlug + ' AND country.slug:' + this.slug
                    break
                }
                case 'travelTypeCountryPlace': {
                    this.refine =
                        'travelTypes.slug:' + this.firstSlug + ' AND place.slug:' + this.slug
                    break
                }
                case 'travelType': {
                    this.refine = 'travelTypes.slug:' + this.slug
                    break
                }
                case 'partnerTravels': {
                    this.refine = 'partners.slug:' + this.slug
                    break
                }
                case 'country': {
                    if (this.isNorway) {
                        // Norgesferie is a special case, works as landing-page for seo @ norge
                        this.refine = 'country.slug:norge'
                    } else {
                        this.refine = 'country.slug:' + this.slug
                    }
                    break
                }
                case 'countryPlace': {
                    this.refine = 'country.slug:' + this.firstSlug + ' AND place.slug:' + this.slug
                    break
                }
                case 'airport': {
                    this.refine = 'startDates.airports.slug:' + this.slug
                    break
                }
            }
        },
        created() {
            this.crawler = !!window.navigator.userAgent.includes('Googlebot')
            // Delaying the push of the dataLayer to ensure that the algolia state is available
            // Not critical that this data is available on page load
            setTimeout(() => this.pushDataLayer(), 1000)
        },
        methods: {
            transformTrips(items, { results }) {
                return items.map((item, index) => ({
                    ...item,
                    index: { index, page: results.page },
                }))
            },
            pushDataLayer() {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    ecomm_pagetype: 'category',
                    ecomm_category: this.category,
                })

                const trips =
                    this.$refs.configure.state.instantSearchInstance.renderState.trips.infiniteHits
                        .results.hits

                window.dataLayer = window.dataLayer || []
                dataLayer.push({
                    event: 'productImpression',
                    ecommerce: {
                        currencyCode: 'NOK',
                        impressions: [
                            trips.map((tour, i) => {
                                return {
                                    name: tour.title,
                                    id: tour.tourId,
                                    price: '',
                                    category: this.pageType,
                                    variant: tour.travelTypes?.length
                                        ? tour.travelTypes[0]?.title
                                        : '',
                                    list: this.title,
                                    position: i,
                                }
                            }),
                        ],
                    },
                })
            },
            onTripClicked(trip, index) {
                let vm = this
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'productClick',
                    ecommerce: {
                        click: {
                            actionField: {
                                list: this.title,
                            },
                            products: [
                                {
                                    name: trip.title,
                                    id: trip.tourId,
                                    price: '',
                                    category: this.category,
                                    variant: trip.travelType,
                                    position: index,
                                },
                            ],
                        },
                    },
                    eventCallback: function () {
                        return (window.location = `${trip.url}?list=${vm.title}`)
                    },
                })

                return (window.location.href = `${trip.url}?list=${vm.title}`)
            },
            async toggleCollapse() {
                const { disableBodyScroll, enableBodyScroll } = await import('body-scroll-lock')

                if (this.collapsed) {
                    this.collapsed = false
                    disableBodyScroll(this.$refs.filter)
                } else {
                    this.collapsed = true
                    enableBodyScroll(this.$refs.filter)
                }
            },
            getAirportListForTrip(trip) {
                let airports = uniq(
                    trip.startDates
                        .flatMap((sd) => sd.airports)
                        .map((airport) => {
                            return airport.title
                        })
                ).join(', ')
                return airports ? airports : 'Ikke satt'
            },
            generateSrcSet(image) {
                const client = new ImgixClient({
                    domain: 'vitus.imgix.net',
                    secureURLToken: 'EtpQBVXpTnm2Bh4s',
                })

                const desktop = { ar: '3:2' }
                const tablet = { ar: '435:284' }
                const mobile = { ar: '378:188' }

                let config = null
                if (window.innerWidth > 1024) {
                    config = desktop
                } else if (window.innerWidth >= 600 && window.innerWidth < 1024) {
                    config = tablet
                } else {
                    config = mobile
                }

                return client.buildSrcSet(
                    image,
                    {
                        position: '50% 50%',
                        allowUpscale: false,
                        fit: 'crop',
                        auto: 'format',
                        ...config,
                    },
                    {
                        minWidth: 150,
                        maxWidth: 500,
                        step: 50,
                    }
                )
            },
        },
        computed: {
            isNorway() {
                return this.segments.includes('norge') || this.segments.includes('norgesferie')
            },
            segments() {
                return window.location.pathname.substring(1).split('/')
            },
        },
    }
</script>
